import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import './styles/FiraSansFont.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
{
    window.location.pathname.toLowerCase() == "/admin" ?
        null
        :
        ReactDOM.render(
            <BrowserRouter basename={baseUrl}>
                {/* <div>Haleluyaa</div> */}
                <App />
            </BrowserRouter>,
            rootElement);
}
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js